import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { onboardingService, UserProfileResponse } from '../../services/onboardingService';

interface Use3YearsVisionReturn {
  profile: UserProfileResponse | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const use3YearsVision = (): Use3YearsVisionReturn => {
  const [profile, setProfile] = useState<UserProfileResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { userId } = useAuth();

  const fetchProfile = async () => {
    if (!userId) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      
      const userProfile = await onboardingService.getUserProfile(userId);
      setProfile(userProfile);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to load profile';
      setError(errorMessage);
      console.error('Error fetching 3-year vision:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [userId]);

  return {
    profile,
    isLoading,
    error,
    refetch: fetchProfile
  };
};
